/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ExamIdMutationRequest,
  PutApiV1ExamIdMutationResponse,
  PutApiV1ExamIdPathParams,
  PutApiV1ExamId400,
  PutApiV1ExamId401,
  PutApiV1ExamId404,
  PutApiV1ExamId500,
} from "../../types/examEvaluationController/PutApiV1ExamId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ExamId } from "../../clients/examEvaluationController/putApiV1ExamId.ts";

export const putApiV1ExamIdMutationKey = () =>
  [{ url: "/api/v1/exam/:id" }] as const;

export type PutApiV1ExamIdMutationKey = ReturnType<
  typeof putApiV1ExamIdMutationKey
>;

export function putApiV1ExamIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1ExamIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1ExamIdMutationKey();
  return mutationOptions<
    PutApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamId400
      | PutApiV1ExamId401
      | PutApiV1ExamId404
      | PutApiV1ExamId500
    >,
    {
      id: PutApiV1ExamIdPathParams["id"];
      data?: PutApiV1ExamIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1ExamId(id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de uma prova existente. A alteração do tipo de prova só é permitida entre os tipos Avaliação do Aluno e Qualificação quando não há idiomas associados com tipo inválido. A edição é bloqueada quando já existem tentativas registradas. **(Requer Authorization para autenticação)**
 * @summary Editar prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:id}
 */
export function usePutApiV1ExamId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ExamIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1ExamId400
        | PutApiV1ExamId401
        | PutApiV1ExamId404
        | PutApiV1ExamId500
      >,
      {
        id: PutApiV1ExamIdPathParams["id"];
        data?: PutApiV1ExamIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1ExamIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1ExamIdMutationKey();

  const baseOptions = putApiV1ExamIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamId400
      | PutApiV1ExamId401
      | PutApiV1ExamId404
      | PutApiV1ExamId500
    >,
    {
      id: PutApiV1ExamIdPathParams["id"];
      data?: PutApiV1ExamIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamId400
      | PutApiV1ExamId401
      | PutApiV1ExamId404
      | PutApiV1ExamId500
    >,
    {
      id: PutApiV1ExamIdPathParams["id"];
      data?: PutApiV1ExamIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamId400
      | PutApiV1ExamId401
      | PutApiV1ExamId404
      | PutApiV1ExamId500
    >,
    {
      id: PutApiV1ExamIdPathParams["id"];
      data?: PutApiV1ExamIdMutationRequest;
    },
    TContext
  >;
}
